import { createContext, useContext } from 'react';

interface UserLocation {
  latitude: number;
  longitude: number;
  accuracy: number;
  timestamp: number;
}

export interface UserLocationContextType {
  location: UserLocation | null;
  error: string | null;
  loading: boolean;
  permissionStatus: PermissionState | 'unsupported' | null;
  requestPermission: () => Promise<void>;
  timezone: string;
  hasLocation: boolean;
}

export const UserLocationContext = createContext<UserLocationContextType | undefined>(undefined);

export function useUserLocationContext() {
  const context = useContext(UserLocationContext);
  if (context === undefined) {
    throw new Error('useUserLocationContext must be used within a UserLocationProvider');
  }
  return context;
}
